module.exports = "<div class=\"sv-skeleton-element\">\n</div>";